import { upload } from "@/apis/common";
import { useConfigContext } from "@/app";
import { ImageUploadItem, ImageUploader, Toast } from "antd-mobile";
import classNames from "classnames";
import isEqual from "lodash/isEqual";
import { useEffect, useMemo, useRef, useState } from "react";
import { v4 } from "uuid";
import styles from "./styles.module.scss";
export type UploadImgValue = ImageUploadItem | undefined;
type UploadImgProps = {
  value?: UploadImgValue;
  onChange?: (val: UploadImgValue) => void;
  getUploading?: (loading: boolean) => void;
  children?: React.ReactNode;
  type?: string;
  className?: string;
};
export const UploadImg = (props: UploadImgProps) => {
  const {
    getSourcePath
  } = useConfigContext();
  const [uploading, setUploading] = useState<boolean>(false);
  const imgContentRef = useRef<string>("");
  const [value, setValue] = useState<UploadImgValue>();
  const [_id] = useState<string>(() => {
    return v4();
  });
  const onUpload = async (file: File): Promise<ImageUploadItem> => {
    const formData = new FormData();
    formData.append("imgFile", file);
    formData.append("type", props.type || "order");
    const result = await upload(formData);
    Toast.show(result.msg);
    setUploading(false);
    if (result && result.data) {
      const url = result.data?.name;
      setUploading(false);
      return {
        url: url || "",
        key: url || ""
      };
    } else {
      Toast.show({
        content: "上传附件失败"
      });
      imgContentRef.current = "";
      return {
        url: "",
        key: ""
      };
    }
  };
  const beforeUpload = (file: File, files: File[]): File | Promise<File | null> | null => {
    return new Promise<File | null>((resolve, reject) => {
      setUploading(true);
      return resolve(file);
    });
  };
  const onFileChange = (files?: ImageUploadItem[]) => {
    let _val;
    if (Array.isArray(files) && files[0] && files[0].url) {
      const file = files[0];
      _val = {
        ...file
      };
    }
    imgContentRef.current = "";
    setValue(_val);
    typeof props.onChange === "function" && props.onChange(_val);
  };
  useEffect(() => {
    typeof props.getUploading === "function" && props.getUploading(uploading);
  }, [uploading, props]);
  useEffect(() => {
    if (isEqual(props.value, value)) {
      setValue(props.value);
    }
  }, [props.value]);
  const _value = useMemo(() => {
    if (value?.url) {
      return [{
        ...value,
        url: getSourcePath(value.url)
      }];
    } else {
      return [];
    }
  }, [value]);
  return <div data-sentry-component="UploadImg" data-sentry-source-file="index.tsx">
      <ImageUploader upload={onUpload} beforeUpload={beforeUpload} multiple={false} preview={false} capture={false} maxCount={1} value={_value} className={classNames(props.className, styles.imageUploader)} onChange={onFileChange} renderItem={() => null} data-sentry-element="ImageUploader" data-sentry-source-file="index.tsx">
        {props.children}
      </ImageUploader>
      <div id={_id} style={{
      display: "none"
    }}></div>
    </div>;
};